module.exports = __webpack_public_path__ + "img/Stop.9c12679b.svg";